<template>
  <login-wrapper>
    <detail-wrapper type="senate">
    </detail-wrapper>
  </login-wrapper>
</template>

<script>
import { DetailWrapper } from '@/components'
import { LoginWrapper } from '@/components/common'

const name = 'senate'

const components = {
  DetailWrapper,
  LoginWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: '2018 Senate Forecast'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Senate.vue